// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--WwZHR";
export var borderRadius = "index-module--border-radius--8ZFME";
export var clearButtonStyles = "index-module--clear-button-styles--DK+YT";
export var on_demand_active_type = "index-module--on_demand_active_type--ag8+6";
export var on_demand_type_ul = "index-module--on_demand_type_ul--3kt4V";
export var titleFont = "index-module--title-font--JS27u";